<template>
  <div class="candidate campaign-eligibilities-list pt-3">
    <!-- Loading -->
    <v-progress-circular indeterminate v-if="loading" :color="themes.candidate.light.loading" />

    <div v-else>
      <p>{{ resultMessage }}</p>
      <v-btn block
        v-for="eligibility in eligibleEligibilities"
        :key="eligibility.id"
        :to="`/opportunities/${eligibility.opportunity.id}`"
        target="_blank"
        :color="themes.candidate.light.secondaryActionButton"
      >
        {{ eligibility.opportunity.name }}
      </v-btn>
    </div>
  </div>
</template>

<script>
// Helpers
import { mapGetters } from 'vuex'

export default {

  created() {
    if (!this.campaign || !this.campaign.id) this.$emit('done')
    this.checkEligibilities()
  },

  data() {
    return {
      eligibilities: [],
      loading: true,
    }
  },

  computed: {
    ...mapGetters({ campaign: 'campaign/model' }),

    eligibleEligibilities() {
      return this.eligibilities.filter(e => e.eligible)
    },

    campaignOrganization() {
      if (!this.campaign) return

      return this.campaign.organization
        ? this.campaign.organization
        : this.campaign.opportunity.organization
    },

    resultMessage() {
      return this.eligibleEligibilities.length
        ? 'Based on the information you provided you qualify for'
        : this.dontQualifyMessage
    },

    dontQualifyMessage() {
      return this.campaign.opportunity
        ? `Based on the information on your profile, you don't qualify for this opportunity at ${
          this.campaignOrganization.name
        }`
        : `Based on the information on your profile, you don't qualify for current open opportunities at ${
          this.campaignOrganization.name
        }`
    },
  },

  methods: {
    checkEligibilities() {
      if (!this.campaign) return

      this.loading = true
      this.$http.get(`candidate/campaigns/${this.campaign.id}/eligibilities`).then(({ data }) => {
        this.eligibilities = data
        this.loading = false
        this.$emit('done')
      })
    },
  },
}
</script>
